import { dataHooks } from '@wix/data-hooks'

export const wixMobilePantoneDataHooks = dataHooks<{
  illustrationImage: {}
  title: {}
  description: {}
}>('wix-mobile-pantone')
